interface Branding { primaryColor: string; secondaryColor: string; headerColor: string }

function lum(hex: string): number {
  const m = (hex || "").replace("#", "");
  if (m.length < 6) return 1; // malformed → treat as "too light" so we fall back
  const r = parseInt(m.slice(0, 2), 16), g = parseInt(m.slice(2, 4), 16), b = parseInt(m.slice(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
}

function inkFor(hex: string): string {
  return lum(hex) > 0.6 ? "#111827" : "#ffffff";
}

const TOO_LIGHT = 0.82;
const DEFAULT_BRAND = "#2563eb";

// The brand accent is used as the background of toggles and primary buttons, so a
// near-white brand color makes them invisible. Fall back to the first dark-enough
// brand color (primary → header → secondary), else a sensible default.
function safeBrand(b: Branding): string {
  for (const c of [b.primaryColor, b.headerColor, b.secondaryColor]) {
    if (c && lum(c) <= TOO_LIGHT) return c;
  }
  return DEFAULT_BRAND;
}

export function themeVars(b: Branding): string {
  const brand = safeBrand(b);
  return [
    `--dp-brand: ${brand};`,
    `--dp-brand-ink: ${inkFor(brand)};`,
    `--dp-accent: ${b.secondaryColor};`,
    `--dp-header: ${b.headerColor};`,
  ].join(" ");
}
